// extracted by mini-css-extract-plugin
export var button = "WhatsappFloatingButton-module--button--3805c";
export var ellipsis = "WhatsappFloatingButton-module--ellipsis--30f37";
export var iconContainer = "WhatsappFloatingButton-module--icon-container--86593";
export var notificationBadge = "WhatsappFloatingButton-module--notificationBadge--514b1";
export var onDisabledJivo = "WhatsappFloatingButton-module--onDisabledJivo--53a92";
export var overlay = "WhatsappFloatingButton-module--overlay--2fb44";